/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoBasicInfoDTO { 
    video_id: string;
    title: string;
    season_id?: number | null;
    match_date?: string | null;
    gender?: string | null;
    competition_id?: number | null;
    category_id?: number | null;
}

